import React from 'react'
import Pane from 'components/Common/Pane'
import Heading from 'components/Luxkit/Typography/Heading'
import { useTranslation } from 'react-i18next'
import Group from 'components/utils/Group'
import PartnerCarousel from 'components/Common/PartnerBrands/PartnerCarousel'
import styled from 'styled-components'
import { rem } from 'polished'

const StyledPane = styled(Pane)`
  margin: ${rem(32)} 0;
`

function HomepagePartnerBrands() {
  const { t } = useTranslation('partners')
  return (
    <StyledPane type="clear">
      <Group direction="vertical" gap={24}>
        <Heading variant="heading5">
          {t('homepagePartnerHeader')}
        </Heading>
        <PartnerCarousel />
      </Group>
    </StyledPane>
  )
}

export default HomepagePartnerBrands
